<template>
  <div>
    <el-button type="primary" size="mini" plain @click="openshowdialog">
      <span class="el-icon-edit-outline">编辑图片</span>
    </el-button>
    <el-dialog title="项目相册" :visible.sync="showdialog" width="1200px" v-dialogDrag append-to-body>
      <div class="base-warp">
        <el-collapse v-model="activeNames" :accordion="false">
          <el-collapse-item v-for="(item, index) in types" :key="index" :name="index">

            <template slot="title">
              <div class="colla-head">
                <span class="text">{{ item }}</span>
                <div class="head-btn">
                  <el-button type="danger" size="mini" icon="el-icon-delete" circle
                    @click.stop="delGroup(item, index)"></el-button>
                </div>
              </div>
            </template>

            <div class="file-warp">
              <div class="img-warp" v-if="item == '外景'">
                <div class="img-box" v-for="(img, ind) in album[item]" :key="ind">
                  <el-button class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle
                    @click.stop="delimg(item, ind)"></el-button>
                  <el-image class="img" :src="img.path" fit="fill" :lazy="true"></el-image>
                </div>
              </div>
              <div class="img-warp" v-else>
                <div class="img-box" v-for="(img, ind) in album[item]" :key="ind">
                  <el-button class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle
                    @click.stop="delimg(item, ind)"></el-button>
                  <el-image class="img" :src="img.path" fit="fill" :lazy="true"></el-image>
                </div>
              </div>
            </div>
            <div class="upl-warp">
              <el-upload class="upload-demo" drag action="/api/Upload/uploadFile/"
                :on-success="(response) => { handleUploadSuccess(item, response) }" :before-upload="beforeUpload"
                :data="{ type: item }" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
              </el-upload>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="btn-box">
        <el-button type="primary" size="mini" @click="confirm">保存</el-button>
        <el-button type="default" size="mini" @click="confirmx">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'addalbum',
  data () {
    return {
      types: ['外景', '办公空间', '公共空间'],
      showdialog: false,
      activeNames: [0],
      thumbnail: '',
      custom: '',
      filesList: [],
      album: {},

    }
  },
  props: {
    falbum: {
      type: Array,
      default () {
        return {}
      }
    },
    id: {
      type: Number,
      default: null,
    },
  },

  mounted (options) {
    if (this.types) {
      for (var typ of this.types) {
        if (typ == '外景') {
          this.album[typ] = [];
        } else {
          this.album[typ] = [];
        }
      }
    }
  },

  methods: {
    openshowdialog () {
      console.log(this.id, '===');
      this.showdialog = true;
      if (this.id) {
        console.log(1);
        this.album = {};
        this.falbum.forEach((item) => {
          if (!this.album[item.name]) {
            this.album[item.name] = [];
          }

          this.album[item.name].push({
            name: item.name,
            path: item.path
          });
        });
      } else {
        console.log(2);
        this.falbum.forEach((item) => {
          if (!this.album[item.name]) {
            this.album[item.name] = [];
          }

          this.album[item.name].push({
            name: item.name,
            path: item.path
          });
        });
      }
      this.$forceUpdate();
    },
    delimg (item, ind) {
      this.album[item].splice(ind, 1);
      // if (!ind && item == '外景') {
      //   this.album[item] = '';
      // } else {
      // }
      this.$forceUpdate()
    },
    delGroup (item, index) {
      if (item == '外景' || item == '办公空间' || item == '公共空间') {
        this.$confirm('这个分类不允许删除')
        return;
      }

      var ind = this.types.indexOf(item);
      if (this.album[item].length > 0) {
        this.$confirm('分类中已经上传了图片，是否确定删除').then(
          confirm => {
            this.types.splice(ind, 1);
            delete this.album[item];
          },
          cancel => { }
        )
        return;
      }
      this.types.splice(ind, 1);
      delete this.album[item];
    },

    // getData() {
    //     this.showdialog = true;
    //     var params = {
    //         id: this.id,
    //     }
    //     this.$api.getProjectAlbumVsId(params).then(
    //     data=>{
    //         let {types, album} = data;
    //         if (types.length>1) {
    //             this.types = types;
    //             for (var t of types){
    //                 if (t=='外景'){
    //                     this.album[t] = '';
    //                 } else {
    //                     this.album[t] = [];
    //                 }
    //             }
    //         }
    //         for(var al of album){
    //             if (al.name=='外景'){
    //                 this.album[al.name] = al.path;
    //             } else {
    //                 this.album[al.name].push(al);
    //             }
    //         }
    //         this.$forceUpdate()
    //     }
    // )
    // },
    confirm () {
      if (this.album) {
        this.$emit('albumok', this.album)
        this.showdialog = false
      } else {
        this.$confirm('请重新关闭页面并重新上传')
        this.showdialog = false

      }

      // return console.log(this.album,'return');
      //   var album = this.album;
      //   var types = this.types;
      //   var alb = [];
      //   for (var ty of types){
      //       if (ty!='外景'){
      //           alb = alb.concat(album[ty])
      //       }
      //   }
      //   var params = {
      //       id: this.id?this.id=this.id : this.id= null,
      //       album: JSON.stringify(alb),
      //       thumbnail: album['外景']
      //   }
      //   this.$api.editProjectAlbum(params).then(
      //   data=>{
      //       this.$message.success(data);
      //       this.showdialog = false;
      //   }
      // )
    },
    confirmx () {
      console.log(this.album, '关闭');
      // this.album = {}
      this.showdialog = false
    },
    handleUploadSuccess (item, response) {

      var that = this
      let { data, errCode, msg } = response;
      if (data) {
        var obj = {
          name: item,
          path: data,
        };
        that.album[item].push(obj);
        that.$forceUpdate()
      } else {
        that.$message.error(msg);
      }
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error('只能上传图片，不能上传其他文件!');
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #f7f7f7;
}

.head {
  .title {
    line-height: 28px;
  }

  .input {
    width: 280px;
  }
}

.colla-head {
  width: 100%;

  .head-btn {
    float: right;
    margin-right: 40px;
  }
}

.file-warp {
  margin-bottom: 4px;

  .img-warp {
    width: 100%;
    overflow: hidden;

    .img-box {
      width: 233px;
      height: 160px;
      border: 1px dashed #eee;
      float: left;
      box-sizing: border-box;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;

      .del-btn {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
      }

      .img {
        width: 230px;
        height: 158px;
        vertical-align: middle;
      }
    }
  }
}

.upl-warp {}
</style>